// extracted by mini-css-extract-plugin
module.exports = {"active":"styles_active__BynNX","timerWrapper":"styles_timerWrapper__DNlBF"};